
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface PrimaryOwnerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  source?: 'portfolio' | 'business';
}

const PrimaryOwnerDialog: React.FC<PrimaryOwnerDialogProps> = ({
  open,
  onOpenChange,
  source = 'portfolio'
}) => {
  const entityType = source === 'portfolio' ? 'Portfolio' : 'Business';
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Cannot Leave {entityType}</DialogTitle>
          <DialogDescription>
            You cannot leave the {source.toLowerCase()} as the Primary Owner. You must transfer ownership to another user first.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            Understood
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PrimaryOwnerDialog;
